import {
  lesson14Assignment1,
  lesson14Assignment1MovePieces,
  lesson14Assignment2
} from './assignments';
import { createChessboard } from '../../utils';
import { BLACK_PIECE_SEARCH_KEY, WHITE_INITIAL_MOVE, WHITE_PIECE_SEARCH_KEY, BLACK_INITIAL_MOVE } from '../../utils/constants';

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 7,
    video: {
      src: 'img/videos/lesson_14/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 3,
    directions: {
      timeout: 0,
      data: 'Can you Capture en passant?',
      className: 'no-animation'
    },
    options: {
      id: 1,
      next: 2,
      answer: [
        'Yes',
        'No'
      ],
      rightAnswer: 'Yes',
      magnusWrongAnswer: {
        data: 'Oops...!!!<br/>The correct answer is YES.',
        styleClass: 'sm',
        waitTime: 4000
      },
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: lesson14Assignment1({
        showIndicators: { allSides: true },
        position: 'rnbqkb1r/ppp2ppp/8/3pP3/3Qn3/5N2/PPP2PPP/RNB1KB1R',
        assignmentClass: 'custom-sparepiece',
        from: 'square-d7',
        to: 'square-d5',
        offset: [5, 5, 5, 2],
        next: 2
      }),
      canvas: true
    }
  },
  {
    id: 2,
    previous: 0,
    next: null,
    chessboard: {
      board: lesson14Assignment1MovePieces({
        showIndicators: { allSides: true },
        position: 'rnbqkb1r/ppp2ppp/8/3pP3/3Qn3/5N2/PPP2PPP/RNB1KB1R',
        finalPosition: 'rnbqkb1r/ppp2ppp/3P4/8/3Qn3/5N2/PPP2PPP/RNB1KB1R',
        assignmentClass: 'custom-sparepiece',
        from: 'square-e5',
        to: 'square-d6',
        offset: [5, 5, 5, 4],
        capture: {
          capturingPiece: 'wP',
          capturedPiece: 'bp'
        },
        next: 3
      }),
      canvas: true
    }
  },
  {
    id: 3,
    previous: 0,
    next: 4,
    directions: {
      timeout: 0,
      data: 'Can you Capture en passant?',
      className: 'no-animation'
    },
    options: {
      id: 2,
      next: 4,
      answer: [
        'Yes',
        'No'
      ],
      rightAnswer: 'No',
      magnusWrongAnswer: {
        data: 'Oops! The correct answer is NO.</br>Only pawns moving two squares might </br> be involved in en passant captures.',
        styleClass: 'xxxl',
        waitTime: 4000
      },
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: lesson14Assignment1({
        showIndicators: { allSides: true },
        position: 'rnbqkbnr/ppp2ppp/4p3/3pP3/3P4/8/PPP2PPP/RNBQKBNR',
        assignmentClass: 'custom-sparepiece',
        from: 'square-e4',
        to: 'square-e5',
        offset: [5, 6, 5, 7],
        next: 4
      }),
      canvas: true
    }
  },
  {
    id: 4,
    previous: 0,
    next: 5,
    directions: {
      timeout: 0,
      data: 'Can you Capture en passant?',
      className: 'no-animation'
    },
    options: {
      id: 3,
      next: 5,
      answer: [
        'Yes',
        'No'
      ],
      rightAnswer: 'No',
      magnusWrongAnswer: {
        data: 'Oops! The correct answer is NO.<br/>Only pawns are involved in en passant <br/> captures, no other pieces.',
        styleClass: 'xxl',
        waitTime: 4000
      },
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: lesson14Assignment1({
        showIndicators: { allSides: true },
        position: 'rnbq2k1/ppp1n1pp/4p3/3pPr2/3P4/5N2/PP2BPPP/RN1Q1RK1',
        assignmentClass: 'custom-sparepiece',
        from: 'square-f8',
        to: 'square-f5',
        offset: [5, 5, 5, 4],
        next: 5
      }),
      canvas: true
    }
  },
  {
    id: 5,
    previous: 0,
    next: 7,
    directions: {
      timeout: 0,
      data: 'Can you Capture en passant?',
      className: 'no-animation'
    },
    options: {
      id: 4,
      next: 6,
      answer: [
        'Yes',
        'No'
      ],
      rightAnswer: 'Yes',
      magnusWrongAnswer: {
        data: 'OOPS! White can capture en passant.',
        styleClass: 'xl',
        waitTime: 4000
      },
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'xs'
    },
    chessboard: {
      board: lesson14Assignment1({
        showIndicators: { allSides: true },
        position: 'r4rk1/1ppqnpb1/3pbnpp/pP2p3/2P5/2NP1NP1/P1QBPPBP/1R3RK1',
        assignmentClass: 'custom-sparepiece',
        from: 'square-a7',
        to: 'square-a5',
        offset: [5, 5, 5, 3],
        next: 6
      }),
      canvas: true
    }
  },
  {
    id: 6,
    previous: 0,
    next: 7,
    chessboard: {
      board: lesson14Assignment1MovePieces({
        showIndicators: { allSides: true },
        position: 'r4rk1/1ppqnpb1/3pbnpp/pP2p3/2P5/2NP1NP1/P1QBPPBP/1R3RK1',
        finalPosition: 'r4rk1/1ppqnpb1/P2pbnpp/4p3/2P5/2NP1NP1/P1QBPPBP/1R3RK1',
        assignmentClass: 'custom-sparepiece',
        from: 'square-b5',
        to: 'square-a6',
        offset: [5, 5, 5, 4],
        capture: {
          capturingPiece: 'wP',
          capturedPiece: 'bp'
        },
        next: 7
      }),
      canvas: true
    }
  },
  {
    id: 7,
    previous: 0,
    next: 12,
    video: {
      src: 'img/videos/lesson_14/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 8
    }
  },
  {
    id: 8,
    previous: 7,
    next: 9,
    directions: {
      data: '<b> DIRECTIONS: </b> </br>Move a White pawn to create a pawn chain.</br> And save your Queen.',
      timeout: 1000
    },
    chessboard: {
      board: lesson14Assignment2({
        position: 'r2q1rk1/1pp1ppbp/n2p1np1/p2P4/4P1b1/2NB4/PPP2PPP/R1BQNRK1',
        final: ['r2q1rk1/1pp1ppbp/n2p1np1/p2P4/4P1b1/2NB1P2/PPP3PP/R1BQNRK1'],
        next: 9,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
        initialMove: WHITE_INITIAL_MOVE,
        failedAttemptMove: 24
      }),
      positionFen: 'r2q1rk1/1pp1ppbp/n2p1np1/p2P4/4P1b1/2NB4/PPP2PPP/R1BQNRK1 w - - 0 1',
    }
  },
  {
    id: 9,
    previous: 7,
    next: 10,
    directions: {
      data: '<b> DIRECTIONS: </b> </br>Move a Black pawn to create a pawn chain.',
      timeout: 1000
    },
    chessboard: {
      board: lesson14Assignment2({
        position: 'rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R',
        final: ['rnbqkbnr/p2p1ppp/1p2p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R', 'rnbqkbnr/pp3ppp/4p3/2pp4/4P3/2P2N2/PP1P1PPP/RNBQKB1R', 'rnbqkbnr/pp1p2pp/4p3/2p2p2/4P3/2P2N2/PP1P1PPP/RNBQKB1R'],
        next: 10,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
        initialMove: BLACK_INITIAL_MOVE,
        failedAttemptMove: 25
      }),
      positionFen: 'rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R b - - 0 1',
    }
  },
  {
    id: 10,
    previous: 7,
    next: 11,
    directions: {
      data: '<b> DIRECTIONS: </b> </br>Move a White pawn to create a pawn chain.',
      timeout: 1000
    },
    chessboard: {
      board: lesson14Assignment2({
        position: 'r1bqkbnr/pp1p1ppp/2n1p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R',
        final: ['r1bqkbnr/pp1p1ppp/2n1p3/2p5/1P2P3/2P2N2/P2P1PPP/RNBQKB1R', 'r1bqkbnr/pp1p1ppp/2n1p3/2p5/3PP3/2P2N2/PP3PPP/RNBQKB1R'],
        next: 11,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
        initialMove: WHITE_INITIAL_MOVE,
        failedAttemptMove: 26
      }),
      positionFen: 'r1bqkbnr/pp1p1ppp/2n1p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R w - - 0 1',
    }
  },
  {
    id: 11,
    previous: 7,
    next: 12,
    directions: {
      data: '<b> DIRECTIONS: </b> </br>Move a Black pawn to create a pawn chain.',
      timeout: 1000
    },
    chessboard: {
      board: lesson14Assignment2({
        position: 'r1bq1rk1/ppp1ppbp/2np1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1',
        final: ['r1bq1rk1/ppp2pbp/2np1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1', 'r1bq1rk1/ppp1ppb1/2np1np1/7p/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1'],
        next: 12,
        showIndicators: { allSides: true },
        MagnusText: 'nice job',
        restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
        initialMove: BLACK_INITIAL_MOVE,
        failedAttemptMove: 27
      }),
      positionFen: 'r1bq1rk1/ppp1ppbp/2np1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 b - - 0 1',
    }
  },
  {
    id: 12,
    previous: 7,
    next: 13,
    video: {
      src: 'img/videos/lesson_14/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 13
    }
  },
  {
    id: 13,
    previous: 12,
    next: 14,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: 'En passant is French for…',
      answer: [
        'What’s happening?',
        'In passing',
        'The pawn',
        'Tie game'
      ],
      rightAnswer: 'In passing',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md',
      rightAnswerTimeout: 7000
    }
  },
  {
    id: 14,
    previous: 12,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: 'En passant is a move using…',
      answer: [
        'pawns',
        'Knights',
        'Bishops',
        'The King and a Rook'
      ],
      rightAnswer: 'pawns',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md',
      rightAnswerTimeout: 7000
    }
  },
  {
    id: 15,
    previous: 12,
    next: 16,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: 'What is one of the questions you </br> have to ask before you move en passant?',
      answer: [
        'Do I still have both of my Knights?',
        'Is my Bishop on a White square?',
        'Did my opponent just move a pawn two squares?',
        'Are the squares between my King and Rook open?'
      ],
      rightAnswer: 'Did my opponent just move a pawn two squares?',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'xxl',
      rightAnswerTimeout: 7000
    }
  },
  {
    id: 16,
    previous: 12,
    next: 17,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: 'What is the other question you have to ask </br> before you move en passant?',
      answer: [
        `Is my Knight checking my opponent's King?`,
        'Is my opponent’s pawn standing next to my pawn?',
        'Does my opponent still have a Queen?',
        'Did my opponent just castle?'
      ],
      rightAnswer: 'Is my opponent’s pawn standing next to my pawn?',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xxl',
      rightAnswerTimeout: 7000
    }
  },
  {
    id: 17,
    previous: 12,
    next: 18,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'White cannot capture en passant because;',
      answer: [
        'The Black pawn did not move two squares.',
        'En passant only happens before you castle.',
        'The pawn that moved two squares is not BESIDE any pawn.',
        'The pawn is pinned'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: 'r4rk1/2qbb1pp/pn1pp1P1/1pn2p1P/3NP3/2N1BP2/PPPQ4/2KR1B1R'
        }),
        hint: true,
        canvas: {
          from: 'square-f7',
          to: 'square-f5',
        }
      },
      rightAnswer: 'The pawn that moved two squares is not BESIDE any pawn.',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'xxl'
    }
  },
  {
    id: 18,
    previous: 12,
    next: 19,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'The black h-pawn just moved two squares.<br/>Think carefully, what is the best move for white?',
      answer: [
        'g5xh6 (en passant)',
        'b2xBc3',
        'Bf7xh5',
        'Rh1xh5#'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '7k/5Bp1/1pp5/6Pp/8/q1b5/PP6/K4R1R'
        }),
        hint: true,
        canvas: {
          from: 'square-h7',
          to: 'square-h5',
        }
      },
      rightAnswer: 'Rh1xh5#',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 19,
    previous: 12,
    next: 20,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'The White b pawn just moved TWO squares.What should Black do?',
      answer: [
        'Congratulate White on winning',
        'Declare the game a tie since black can’t move.',
        'Capture en passant and get a new Queen two moves later.',
        'all of the above'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '6k1/6P1/6K1/8/pP6/P7/8/8'
        }),
        hint: true,
        canvas: {
          from: 'square-b2',
          to: 'square-b4'
        }
      },
      rightAnswer: 'Capture en passant and get <br/> a new Queen two moves later,',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'xxl'
    }
  },
  {
    id: 20,
    previous: 12,
    next: 21,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'The White b pawn just moved ONE square.<br/>What should Black do?',
      answer: [
        'Congratulate White on winning',
        'Declare the game a tie because he cannot move.',
        'Capture en passant and get a new Queen two moves later.',
        'all of the above'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '6k1/6P1/6K1/8/pP6/P7/8/8'
        }),
        hint: true,
        canvas: {
          from: 'square-b3',
          to: 'square-b4',
        }
      },
      rightAnswer: 'Declare the game a tie because he cannot move.',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xxl'
    }
  },
  {
    id: 21,
    previous: 12,
    next: 22,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 8,
      question: 'En passant usually happens...',
      answer: [
        'as an opening move for pawns',
        'any time during the game',
        'when there are only pawns on the board',
        'to checkmate the King'
      ],
      rightAnswer: 'any time during the game',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xl'
    }
  },
  {
    id: 22,
    previous: 12,
    next: 23,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 9,
      question: 'The White pawn just moved c2-c4, Black can capture en passant. Is there a better move?',
      answer: [
        'No, en passant is the best move.',
        'Yes, Black could move Nh3#',
        'Yes, Black could move h4xg3',
        'Yes, Black could move Bd6xg3'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '2k5/5p2/3b2p1/3b4/2Pp3p/3P2P1/5n1P/2R2RK1'
        }),
        hint: true,
      },
      rightAnswer: 'Yes, Black could move Nh3#',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'xl'
    }
  },
  {
    id: 23,
    previous: 12,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      nextLesson: 'Lesson Fifteen',
      result: true,
      styleClass: 'xl'
    }
  },
  {
    id: 24,
    previous: 0,
    next: 9,
    chessboard: {
      board: lesson14Assignment2({
        showIndicators: { allSides: true },
        position: 'r2q1rk1/1pp1ppbp/n2p1np1/p2P4/4P1b1/2NB4/PPP2PPP/R1BQNRK1',
        final: 'r2q1rk1/1pp1ppbp/n2p1np1/p2P4/4P1b1/2NB1P2/PPP3PP/R1BQNRK1',
        assignmentClass: 'custom-sparepiece',
        from: 'f2',
        to: 'f3',
        next: 9,
      }),
    }
  },
  {
    id: 25,
    previous: 0,
    next: 9,
    chessboard: {
      board: lesson14Assignment2({
        showIndicators: { allSides: true },
        position: 'rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R',
        final: 'rnbqkbnr/pp3ppp/4p3/2pp4/4P3/2P2N2/PP1P1PPP/RNBQKB1R',
        assignmentClass: 'custom-sparepiece',
        from: 'd7',
        to: 'd5',
        next: 10,
      }),
    }
  },
  {
    id: 26,
    previous: 0,
    next: 9,
    chessboard: {
      board: lesson14Assignment2({
        showIndicators: { allSides: true },
        position: 'r1bqkbnr/pp1p1ppp/2n1p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R',
        final: 'r1bqkbnr/pp1p1ppp/2n1p3/2p5/1P2P3/2P2N2/P2P1PPP/RNBQKB1R',
        assignmentClass: 'custom-sparepiece',
        from: 'b2',
        to: 'b4',
        next: 11,
      }),
    }
  },
  {
    id: 27,
    previous: 0,
    next: 9,
    chessboard: {
      board: lesson14Assignment2({
        showIndicators: { allSides: true },
        position: 'r1bq1rk1/ppp1ppbp/2np1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1',
        final: 'r1bq1rk1/ppp2pbp/2np1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1',
        assignmentClass: 'custom-sparepiece',
        from: 'e7',
        to: 'e5',
        next: 12,
      }),
    }
  }
];

// ToDo: add images for 13 and 15
let assets = [
  '/img/background_14.png',
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_14/index.js